import React from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const ActionButtons = ({ onApplyFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { buttonApply, buttonReset }
  } = localizedStrings;
  return (
    <div
      style={{
        marginTop: '2rem',
        display: 'flex'
      }}
    >
      <Button onClick={() => onApplyFilters()} variant={{ priority: 'low' }}>
        {buttonApply}
      </Button>
      <div style={{ marginLeft: '1rem' }}>
        <Button onClick={() => onApplyFilters(true)}>{buttonReset}</Button>
      </div>
    </div>
  );
};

ActionButtons.propTypes = {
  onApplyFilters: PropTypes.func.isRequired
};

export default ActionButtons;
